import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { OrgProvider } from './context/OrgContext';
import RequirePortalLogin from './components/RequirePortalLogin';
import Homepage from './pages/Homepage';
import GSTDashboard from './pages/GSTDashboard';
import GSTRegistration from './pages/GSTRegistration';
import GSTR1Dashboard from './pages/GSTR1Dashboard';
import GSTR3BDashboard from './pages/GSTR3BDashboard';
import OrgLoginPage from './pages/OrgLoginPage';
import { Navigate } from 'react-router-dom';
import B2BDemoPage from './pages/B2BDemoPage';
import DemoInstitutePage from './pages/DemoInstitutePage';
import BookDemoPage from './pages/BookDemoPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import AdminPage from './pages/AdminPage';
import AdminWorkshopsPage from './pages/AdminWorkshopsPage';
// PWBatchPage import removed — /pw route deprecated (partnership ended).
// Component file kept on disk for now; remove in next cleanup pass.
import Gstr1Simulator from './pages/simulator/Gstr1Simulator';
import Gstr3bSimulator from './pages/simulator/Gstr3bSimulator';

// Science Lab Pages
import ScienceLabPage from './pages/ScienceLabPage';
import CircuitLabPage from './pages/CircuitLabPage';
import PhysicsLabPage from './pages/PhysicsLabPage';
import SimpleMachinesPage from './pages/SimpleMachinesPage';
import BiologyLabPage from './pages/BiologyLabPage';
import RoboticsLabPage from './pages/RoboticsLabPage';

// World-Class Science Simulations
import LightBenderSimulation from './pages/simulations/LightBenderSimulation';
import ElementBuilderSimulation from './pages/simulations/ElementBuilderSimulation';
import HeartPumpSimulation from './pages/simulations/HeartPumpSimulation';
import ClimateSimulator from './pages/simulations/ClimateSimulator';

// Interview Bot
import InterviewBotPage from './pages/InterviewBotPage';

// TDS Return Filing
import TDSReturnPage from './pages/TDSReturnPage';
import FinanceSimulator from './pages/FinanceSimulator';

// User Portal (Email + OTP auth)
import UserPortalLoginPage from './pages/UserPortalLoginPage';
import UserPortalPage from './pages/UserPortalPage';

// Science Lab — CBSE/NCERT chapter-wise simulators
import Class9SciencePage from './pages/science/Class9SciencePage';
import MatterStatesSimulation from './pages/science/simulations/MatterStatesSimulation';
import MotionSimulation from './pages/science/simulations/MotionSimulation';

// Domain Migration Banner (env-gated)
import MigrationBanner from './components/MigrationBanner';

function App() {
  return (
    <AuthProvider>
      <OrgProvider>
        <div className="App">
          <BrowserRouter>
            <MigrationBanner />
            <Routes>
              {/* B2C Routes */}
              <Route path="/" element={<Homepage />} />
              <Route path="/gst" element={<GSTDashboard />} />
              <Route path="/portal/login" element={<UserPortalLoginPage />} />
              <Route path="/portal" element={<UserPortalPage />} />

              {/* Science Lab — CBSE/NCERT chapter-wise simulators */}
              <Route path="/science/class-9" element={<Class9SciencePage />} />
              <Route path="/science/class-9/matter-in-our-surroundings" element={<MatterStatesSimulation />} />
              <Route path="/science/class-9/motion" element={<MotionSimulation />} />

              {/* Legacy /login → redirect to new portal login */}
              <Route path="/login" element={<Navigate to="/portal/login" replace />} />
              <Route path="/gst/registration" element={<RequirePortalLogin label="the GST Registration simulator"><GSTRegistration /></RequirePortalLogin>} />
              <Route path="/gst/gstr1" element={<RequirePortalLogin label="the GSTR-1 simulator"><Gstr1Simulator /></RequirePortalLogin>} />
              <Route path="/gst/gstr3b" element={<RequirePortalLogin label="the GSTR-3B simulator"><Gstr3bSimulator /></RequirePortalLogin>} />
              
              {/* PW Batch route removed — external partnership deprecated. /pw → home via NotFound fallback. */}
              
              {/* Science Lab Routes */}
              <Route path="/science" element={<ScienceLabPage />} />
              <Route path="/science/circuits" element={<CircuitLabPage />} />
              <Route path="/science/physics" element={<PhysicsLabPage />} />
              <Route path="/science/machines" element={<SimpleMachinesPage />} />
              <Route path="/science/biology" element={<BiologyLabPage />} />
              <Route path="/science/robotics" element={<RoboticsLabPage />} />
              
              {/* World-Class Science Simulations */}
              <Route path="/science/simulations/light-bender" element={<LightBenderSimulation />} />
              <Route path="/science/simulations/element-builder" element={<ElementBuilderSimulation />} />
              <Route path="/science/simulations/heart-pump" element={<HeartPumpSimulation />} />
              <Route path="/science/simulations/climate" element={<ClimateSimulator />} />
              
              {/* Interview Bot */}
              <Route path="/interview" element={<InterviewBotPage />} />
              
              {/* Income Tax - TDS Return Filing */}
              <Route path="/income-tax/tds" element={<RequirePortalLogin label="the TDS Return simulator"><TDSReturnPage /></RequirePortalLogin>} />

              {/* Finance — Ratios Simulator */}
              <Route path="/finance/ratios" element={<RequirePortalLogin label="the Finance Ratios simulator"><FinanceSimulator /></RequirePortalLogin>} />
              
              {/* Policy Pages */}
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/refund-policy" element={<RefundPolicyPage />} />
              
              {/* Simulator Routes */}
              <Route path="/simulator/gstr1" element={<RequirePortalLogin label="the GSTR-1 simulator"><Gstr1Simulator /></RequirePortalLogin>} />
              <Route path="/simulator/gstr3b" element={<RequirePortalLogin label="the GSTR-3B simulator"><Gstr3bSimulator /></RequirePortalLogin>} />
              
              {/* Admin */}
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin/workshops" element={<AdminWorkshopsPage />} />
              
              {/* B2B Demo & Showcase Routes */}
              <Route path="/for-business" element={<B2BDemoPage />} />
              <Route path="/demo-institute" element={<DemoInstitutePage />} />
              <Route path="/book-demo" element={<BookDemoPage />} />
              
              {/* B2B Organization Routes */}
              <Route path="/:slug/login" element={<OrgLoginPage />} />
              <Route path="/:slug" element={<OrgLoginPage />} />
              <Route path="/:slug/gst" element={<GSTDashboard />} />
              <Route path="/:slug/gst/registration" element={<GSTRegistration />} />
              <Route path="/:slug/gst/gstr1" element={<GSTR1Dashboard />} />
              <Route path="/:slug/gst/gstr3b" element={<GSTR3BDashboard />} />
            </Routes>
          </BrowserRouter>
        </div>
      </OrgProvider>
    </AuthProvider>
  );
}

export default App;
